export default __webpack_public_path__ + "static/media/rotten-tomatoes-icon.c95e89ca.png";